import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmail } from 'validator';
import * as actions from '../../store/modules/auth/actions';
import { Carregando } from '../components';

export default function OficinaLogin() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState('');

  const entrar = (e) => {
    e.preventDefault();
    const emailTratado = email.trim().toLowerCase();

    if (!isEmail(emailTratado)) {
      setErro('E-mail inválido.');
      return;
    }
    if (!senha.trim()) {
      setErro('Senha deve ser informada.');
      return;
    }

    setErro('');
    dispatch(actions.loginRequest({ email: emailTratado, senha }));
  };

  return (
    <div className="oficina-login">
      <div className="oficina-login-marca">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" />
        <h1>elo<strong>Oficina</strong></h1>
        <p>Inspeção veicular com fotos</p>
      </div>

      <form className="oficina-card" onSubmit={entrar} noValidate>
        <h2>Informe seus dados</h2>

        <label className="oficina-campo" htmlFor="oficinaEmail">
          <span>E-mail</span>
          <input
            id="oficinaEmail"
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="seu@email.com"
            value={email}
            onChange={(e) => { setEmail(e.target.value.trim()); setErro(''); }}
          />
        </label>

        <label className="oficina-campo" htmlFor="oficinaSenha">
          <span>Senha</span>
          <div className="oficina-senha">
            <input
              id="oficinaSenha"
              type={mostrarSenha ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="Digite sua senha"
              value={senha}
              onChange={(e) => { setSenha(e.target.value); setErro(''); }}
            />
            <button type="button" aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'} onClick={() => setMostrarSenha(!mostrarSenha)}>
              <i className={`pi ${mostrarSenha ? 'pi-eye-slash' : 'pi-eye'}`} />
            </button>
          </div>
        </label>

        {erro ? <p className="oficina-erro">{erro}</p> : null}

        {isLoading ? (
          <Carregando texto="Entrando..." />
        ) : (
          <button type="submit" className="oficina-botao oficina-botao-primario oficina-botao-bloco">
            Entrar <i className="pi pi-arrow-right" />
          </button>
        )}
      </form>

      <span className="oficina-rodape">Elo Sistemas</span>
    </div>
  );
}
